import { ErrorKey } from '../app-active-error/ErrorKey';
import { setAuth, setAuthHubless } from '../auth/authUtils';
import { getSentryExtra } from '../error/getSentryExtra';
import { isPostVerification } from '../flow-settings/settingsSelectors';
import Logger from '../lib/Logger';
import { OAuthProviders } from '../oauth/OAuthProviders';
import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { setHasRefreshedNewPortalAuth, setIsExistingUserSession, setIsMicrosoftLoading, setIsNewUser } from '../store/app/action-creators';
import { AppActionTypes } from '../store/app/action-types';
import { getWhichOAuthSelected } from '../store/app/selectors';
import { existingOAuthUser, initializeAuth, oAuthExistingAuthFailed } from '../store/auth/action-creators';
import { setError } from '../store/error/action-creators';
import { reloadFlow } from '../store/flow/action-creators';
import { Tracker } from '../store/tracking/action-creators';
const LOG = Logger.getLogger('EndpointsAuth');

const storeAuthResponse = (response, dispatch) => {
  const {
    hubIds = []
  } = response;

  if (hubIds.length) {
    PortalIdContainer.set(PortalIdContainer.get() || hubIds[0]);
    dispatch(setAuth(response));
  } else {
    dispatch(setAuthHubless(response));
  }
};

export const handleSetupAuthSuccess = (response, dispatch) => {
  storeAuthResponse(response, dispatch);

  if (response) {
    dispatch(initializeAuth(true, response.email));
    dispatch(Tracker.authState('authed'));
    dispatch(setIsExistingUserSession(true));

    if (!isPostVerification()) {
      dispatch(Tracker.signupPageView('authenticated'));
    }
  }
};
export const handleSetupAuthFailure = (error, dispatch) => {
  dispatch(initializeAuth(false));
  dispatch(Tracker.authState('not-authed'));

  if (!isPostVerification()) {
    dispatch(Tracker.signupPageView('unauthenticated'));
  }
};
export const handleSetupAuthForNewPortalSuccess = (response, dispatch) => {
  storeAuthResponse(response, dispatch);
  dispatch(setHasRefreshedNewPortalAuth(true));
  dispatch({
    type: AppActionTypes.SignupEnded
  });
};
export const handleSetupAuthForNewPortalFailure = error => {
  LOG.error('authentication after portal login error', {
    extra: getSentryExtra(error)
  });
};
export const handleSetupAuthForOAuthExistingUserSuccess = (response, dispatch, getState) => {
  storeAuthResponse(response, dispatch);
  const state = getState();
  const oAuthProviderSelected = getWhichOAuthSelected(state);

  if (response && oAuthProviderSelected) {
    dispatch(existingOAuthUser(response.email, oAuthProviderSelected));
    dispatch(setIsNewUser(false));
    dispatch(reloadFlow());

    if (oAuthProviderSelected === OAuthProviders.Microsoft) {
      dispatch(setIsMicrosoftLoading(false));
    }
  }
};
export const handleSetupAuthForOAuthExistingUserFailure = (error, dispatch, getState) => {
  const state = getState();
  const oAuthProviderSelected = getWhichOAuthSelected(state);

  if (oAuthProviderSelected) {
    LOG.error(`Error verifying ${oAuthProviderSelected} oauth on login service`, {
      extra: getSentryExtra(error)
    });
    dispatch(oAuthExistingAuthFailed(oAuthProviderSelected));
  } else {
    LOG.error(`Missing oAuthProvider`, {
      extra: getSentryExtra(error)
    });
  }

  dispatch(setError(ErrorKey.OAuthExistingLoginFailed, error));

  if (oAuthProviderSelected === OAuthProviders.Microsoft) {
    dispatch(setIsMicrosoftLoading(false));
  }
};